// this refers to forum itself (forumData)
export const FORUM_DATA_CATEGORIES_MANAGER_ID = 'FORUM_DATA_CATEGORIES_MANAGER_ID';
// placeholder id for when creating new category
export const TEMPLATE_CATEGORY_ID = 'TEMPLATE_CATEGORY_ID';
export const TEMPLATE_CATEGORY_GROUP_ID = 'TEMPLATE_CATEGORY_GROUP_ID';
